<template>
    <div class="featured_runner_section">
        <div class="featured_runner_section_header">
            <h6 class="featured_runner_section_title">
                {{
                    has_finishers ? $t("finishers")
                        : $t("favoris") }}
            </h6>
            <div v-if="showSexSelector" class="featured_runner_sex_toggle" role="group"
                :aria-label="$t('tab_courses.featured_sex_filter_aria')">
                <button type="button" class="featured_runner_sex_btn" :class="{ active: selectedSex === 'M' }"
                    @click="selectedSex = 'M'">{{ $t('tab_courses.featured_sex_m') }}</button>
                <button type="button" class="featured_runner_sex_btn" :class="{ active: selectedSex === 'F' }"
                    @click="selectedSex = 'F'">{{ $t('tab_courses.featured_sex_f') }}</button>
            </div>
        </div>
        <div v-for="(runner, index) in displayRows" :key="runnerKey(runner, index)"
            class="d-flex flex-row justify-start align-items-center gap-1 featured_runner_section_item cursor-pointer"
            :class="{ 'featured_runner_section_item--placeholder': !runner }" @click="goToRunner(runner)">



            <template v-if="runner">
                <div v-if="runner.classement" class="d-flex flex-row align-items-center gap">
                    <img v-if="runner.classement == 1" src="../../assets/medaille/or.png" class="medaille_podium" />
                    <img v-if="runner.classement == 2" src="../../assets/medaille/argent.png" class="medaille_podium" />
                    <img v-if="runner.classement == 3" src="../../assets/medaille/bronze.png" class="medaille_podium" />
                    <div class="font-weight-bold"><b>{{ runner.classement }}</b></div>
                </div>
                <div v-else class="itra_value d-flex flex-column gap-1">
                    <div class="d-flex flex-row align-items-center"
                        v-if="runner.cote_betrail && runner.cote_betrail > 0"> <img src="../../assets/betraillogo.png"
                            alt="betrail" class="betrail_logo_filter" />
                        <span>{{
                            runner.cote_betrail }}</span>
                    </div>
                    <div class="d-flex flex-row align-items-center" v-else-if="runner.itra && runner.itra > 0"> <img
                            src="../../assets/Logo_itra_Simple_N blanc.png" alt="itra" class="itra_logo_filter" />
                        <span>{{
                            runner.itra }}</span>
                    </div>

                </div>
                <div class="d-flex flex-column">
                    <div class="d-flex flex-row align-items-center flex-wrap gap-1">

                        <div v-if="runner.dossard && runner.dossard != '' && runner.dossard != '0'"
                            class="dossard_container">[{{ runner.dossard }}]
                        </div>
                        <div class="runner_name">{{ runner.nom }} {{ runner.prenom }}</div>


                    </div>
                    <div v-if="runner.temps" class="time_container">{{ runner.temps }}</div>

                </div>
            </template>
            <div v-else class="featured_runner_section_placeholder" aria-hidden="true">&nbsp;</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["favorites", "finishers"],

    data() {
        return {
            selectedSex: "M",
        };
    },

    computed: {
        has_finishers() {
            return this.listLength(this.finishers) > 0;
        },
        has_favorites() {
            return this.listLength(this.favorites) > 0;
        },
        sourceData() {
            return this.has_finishers ? this.finishers : this.favorites;
        },
        isGroupedBySex() {
            const d = this.sourceData;
            if (!d || Array.isArray(d) || typeof d !== "object") {
                return false;
            }
            return Array.isArray(d.M) || Array.isArray(d.F);
        },
        showSexSelector() {
            return this.isGroupedBySex;
        },
        runners() {
            const d = this.sourceData;
            if (!d) {
                return [];
            }
            if (Array.isArray(d)) {
                return d;
            }
            if (this.isGroupedBySex) {
                const list = d[this.selectedSex];
                return Array.isArray(list) ? list : [];
            }
            return [];
        },
        displayRows() {
            const list = this.runners.slice(0, 3);
            const pad = Math.max(0, 3 - list.length);
            return list.concat(Array(pad).fill(null));
        },
    },

    watch: {
        sourceData: {
            immediate: true,
            handler() {
                this.syncDefaultSex();
            },
        },
    },

    methods: {
        syncDefaultSex() {
            if (!this.isGroupedBySex) {
                return;
            }
            const d = this.sourceData;
            const hasM = Array.isArray(d.M) && d.M.length > 0;
            const hasF = Array.isArray(d.F) && d.F.length > 0;
            const currentList = d[this.selectedSex];
            const currentHasData = Array.isArray(currentList) && currentList.length > 0;
            if (currentHasData) {
                return;
            }
            if (hasM) {
                this.selectedSex = "M";
            } else if (hasF) {
                this.selectedSex = "F";
            }
        },
        goToRunner(runner) {
            if (!runner.id_live) {
                return;
            }
            this.$router.push({ name: 'Fiche', params: { id_coureur: runner.id_live } });
        },
        listLength(data) {
            if (!data) {
                return 0;
            }
            if (Array.isArray(data)) {
                return data.length;
            }
            if (typeof data === "object") {
                const m = Array.isArray(data.M) ? data.M.length : 0;
                const f = Array.isArray(data.F) ? data.F.length : 0;
                return m + f;
            }
            return 0;
        },
        runnerKey(runner, index) {
            if (!runner) {
                return `placeholder-${index}`;
            }
            if (runner.id_live != null) {
                return String(runner.id_live);
            }
            const d = runner && runner.dossard != null ? runner.dossard : "";
            const n = runner && runner.nom != null ? runner.nom : "";
            const p = runner && runner.prenom != null ? runner.prenom : "";
            return `${d}-${n}-${p}-${index}`;
        },
    },
}
</script>

<style lang="scss" scoped></style>
